import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        signInContainer: {
            textAlign: 'center',
            '& > svg': {
                maxWidth: '10rem',
            },
            [theme.breakpoints.up('sm')]: {
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            },
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: theme.spacing(2),
        },
        forgotPassword: {
            textAlign: 'right',
        },
        cancelIcon: {
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },
        cancelText: {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        errorMessage: {
            textAlign: 'center',
        },
        input: {
            marginTop: 0,
            minWidth: theme.spacing(8),
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        qrCode: {
            display: 'flex',
            justifyContent: 'center',
            margin: '2rem',
        },
        logotype: {
            display: 'flex',
            justifyContent: 'center',
            '& > svg': {
                height: '12rem',
                width: '12rem',
            },
        },
        loginContainer: {
            marginTop: theme.spacing(2),
        },
        progress: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: theme.spacing(4),
        },
        cancel: {
            marginTop: theme.spacing(2),
        },
    };
};
